// extracted by mini-css-extract-plugin
export default {"hexagon":"Hexagon_hexagon__u7lRP","popup":"Hexagon_popup__2Uene","open":"Hexagon_open__dp91z","box":"Hexagon_box__r23Gl","popup_box":"Hexagon_popup_box__QHenP"};